import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "list-group" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_4 = ["value"]

import { computed } from 'vue'
    import type { DiscreteScaleLevelReadModel } from '@Scales/readmodels'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PanelistSurveyVoteEditorDr',
  props: {
    propValue: {},
    propComment: {},
    propScaleLevels: {}
  },
  emits: ["update-value", "update-comment"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- derived ---------------- */

    const value = computed<number | null>(() => props.propValue ?? null)
    const comment = computed<string | null>(() => props.propComment ?? null)
    const scaleLevels = computed(() => props.propScaleLevels)

    /* ---------------- helpers ---------------- */

    function IsSelected(val: number | null): boolean
    {
        return value.value === val
    }

    /* ---------------- actions ---------------- */

    function updateValue(val: number | null)
    {
        if (val !== value.value)
        {
            emit('update-value', val)
        } else
        {
            emit('update-value', null)
        }
    }

    function updateComment(comment: string)
    {
        emit('update-comment', comment)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scaleLevels.value, (l) => {
        return (_openBlock(), _createElementBlock("button", {
          key: l.Value,
          class: _normalizeClass(["list-group-item list-group-item-action text-left", { 'active': l.Value === value.value }]),
          onClick: ($event: any) => (updateValue(l.Value))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["fa", l.Value === value.value ? 'fa-check-circle' : 'fa-circle-thin'])
          }, null, 2 /* CLASS */),
          _createTextVNode(" " + _toDisplayString(l.Name) + " (" + _toDisplayString(l.Value) + ") ", 1 /* TEXT */),
          (l.Definition)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(l.Definition), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_2))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("textarea", {
      rows: "3",
      value: comment.value,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (updateComment($event.target.value))),
      class: "form-control my-3",
      placeholder: "Comment..."
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4)
  ]))
}
}

})